import { subjectDetailsActionTypes } from './Constants';

const initialState = {
	loading: true,
	subjectDetails: null,
	loadingTopics: true,
	subjectDetailsTopics: {},
	loadingExams: true,
	subjectExams: {},
	appliedFilters: {},
	examsFilters: {},
};

export default function subjectDetailsReducer(state = initialState, { type, payload }) {
	const { data } = payload || {};
	const { callback } = data || {};

	switch (type) {
		case subjectDetailsActionTypes.GET_SUBJECT_DETAILS:
			return {
				...state,
				loading: true,
			};

		case subjectDetailsActionTypes.GET_SUBJECT_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				subjectDetails: data,
			};

		case subjectDetailsActionTypes.GET_SUBJECT_DETAILS_ERROR:
			return {
				...state,
				loading: false,
			};

		case subjectDetailsActionTypes.GET_SUBJECT_TOPICS:
			return {
				...state,
				loadingTopics: true,
			};

		case subjectDetailsActionTypes.GET_SUBJECT_TOPICS_SUCCESS:
			return {
				...state,
				loadingTopics: false,
				subjectDetailsTopics: data,
			};

		case subjectDetailsActionTypes.GET_SUBJECT_TOPICS_ERROR:
			return {
				...state,
				loadingTopics: false,
			};

		case subjectDetailsActionTypes.GET_SUBJECT_EXAMS:
			return {
				...state,
				loadingExams: !callback,
			};

		case subjectDetailsActionTypes.GET_SUBJECT_EXAMS_SUCCESS:
			return {
				...state,
				loadingExams: false,
				subjectExams: data,
			};

		case subjectDetailsActionTypes.GET_SUBJECT_EXAMS_ERROR:
			return {
				...state,
				loadingExams: false,
			};

		case subjectDetailsActionTypes.SET_SUBJECT_DETAILS_LISTS_LOADING:
			return {
				...state,
				loadingTopics: true,
				loadingRecent: true,
				loadingExams: true,
			};

		case subjectDetailsActionTypes.CHANGE_SUBJECT_TOPICS_FILTERS:
			return {
				...state,
				...data,
			};

		case subjectDetailsActionTypes.CLEAN_SUBJECT_DETAILS_STATE:
			return initialState;

		default:
			return state;
	}
}
